export function createGetShapeFrames() {
	const shapeCache = {};

	return async function getShapeFrames(shape) {
		if (!shape) {
			return [];
		}
		if (shapeCache[shape]) {
			return shapeCache[shape];
		}

		const response = await fetch(`api.php?action=list&shape=${encodeURIComponent(shape)}`);
		const data = await response.json();
		if (!response.ok || !data.ok) {
			throw new Error(data.error || `Failed to load shape ${shape}`);
		}

		const frames = (data.items || [])
			.map((item) => item.path)
			.filter((path) => typeof path === 'string' && path.length > 0);

		shapeCache[shape] = frames;
		return frames;
	};
}
